import React, { useState } from 'react';
import "./css/bootstrap.css"
import "./css/app.css"
import { Home } from "./components/Home"
import { Navigation } from "./components/Navigation"
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Projects } from './components/Projects';
import { Blog } from './components/Posts';

function App() {
  const [page, setPage] = useState(1);
  return (
    <div className="allapp">
      <Navigation changeFunc={setPage} />
      {page === 1 && <Home />}
      {page === 2 && <About />}
      {page === 3 && <Contact />}
      {page === 4 && <Projects />}
      {page === 5 && <Blog />}
    </div>
  );
}

export default App;
